import { DeprecatedThemeOptions, ThemeOptions } from "@mui/material/styles";

export const typographyVariants = (htmlFontSize?: number): Partial<DeprecatedThemeOptions> => {
	return {
		typography: (palette) => ({
			htmlFontSize,
			allVariants: {
				color: palette.dirtyWhite["2000"],
			},
			fontFamily: "Nunito",
			button: {
				textTransform: "capitalize",
				fontWeight: 800,
				fontSize: 16,
				lineHeight: 1, // 16px
			},
			xs: {
				fontSize: 12,
				fontWeight: 400,
				lineHeight: 1.333, // 16px
			},
			sm: {
				fontSize: 14,
				fontWeight: 400,
				lineHeight: 1.428, // 20px
			},
			md: {
				fontSize: 16,
				fontWeight: 400,
				lineHeight: 1.5, // 24px
			},
			lg: {
				fontSize: 18,
				fontWeight: 400,
				lineHeight: 1.444, // 26px
			},
			xl: {
				fontSize: 20,
				fontWeight: 400,
				lineHeight: 1.4, // 28px
			},
			xxl: {
				fontSize: 24,
				fontWeight: 400,
				lineHeight: 1.333, // 32px
			},
			jm: {
				fontSize: 38,
				fontWeight: 400,
				lineHeight: 1.263, // 48px
			},
			body1: {
				fontSize: 14,
				fontWeight: 400,
				lineHeight: 1.428, // 20px
			},
		}),
	};
};

export const typographyOverrides: ThemeOptions["components"] = {
	MuiTypography: {
		defaultProps: {
			variantMapping: {
				xs: "p",
				sm: "p",
				md: "p",
				lg: "p",
				xl: "p",
				xxl: "p",
				jm: "p",
			},
		},
	},
};
